// extracted by mini-css-extract-plugin
export var productImage = "_m1-1";
export var viewLink = "_m1-2";
export var wishlistItem = "_m1-0";